import { useDispatch, useSelector } from "react-redux";
import {
  updateTitle,
  updateJobDesignation,
} from "../../../../../store/steps/stepOneSlice";
import { RootState } from "../../../../../store";
import GenericInput from "../../../../../common/GenericInput";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { SIZES } from "../../../../../utils/enums";

const BasicInfo = () => {
  const dispatch = useDispatch();
  const { title, jobDesignation } = useSelector(
    (state: RootState) => state.stepOne
  );

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTitle(e.target.value));
  };

  const handleJobDesigChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateJobDesignation(e.target.value));
  };

  return (
    <div className="flex flex-col w-2/5 mx-auto h-4/5 my-auto justify-around">
      <div className="flex flex-col p-2">
        <div className="font-medium p-2">
          {STATIC_STRINGS.TITLE_FOR_ASSESSMENT}
        </div>
        <GenericInput
          type="text"
          onChange={handleTitleChange}
          placeholder={STATIC_STRINGS.ASSESSMENT_TITLE_PLACEHOLDER}
          value={title}
          size={SIZES.md}
        />
      </div>
      <div className="flex flex-col p-2">
        <div className="font-medium p-2">{STATIC_STRINGS.JOB_DESIGNATION}</div>
        <GenericInput
          type="text"
          onChange={handleJobDesigChange}
          placeholder={STATIC_STRINGS.JOB_ROLE}
          value={jobDesignation}
          size={SIZES.md}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
